import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'components/Image';
import { getPreviewPassImage, isEpgv2Enabled } from 'helpers/ConfigHelper';
import expiredPreviewPassV2 from 'themes/ExpiredPreviewPassV2.module.scss';
import expiredPreviewPass from 'themes/ExpiredPreviewPass.module.scss';

const Style = isEpgv2Enabled() ? expiredPreviewPassV2 : expiredPreviewPass;

const Legacy = ({ isActive, openOverlay, backgroundInline, sharedTheme }) => {
  if (!isActive) return null;

  const innerContainerStyle = backgroundInline ? { ...backgroundInline } : {};
  const image = getPreviewPassImage();
  const {
    previewPass_expired_header: headerText,
    previewPass_expired_text: text,
    previewPass_expired_button: buttonText,
  } = window.Language;

  return (
    <div className={classNames(sharedTheme.container, Style.container)}>
      <div
        className={classNames(Style.innerContainer, Style.previewPassExpired)}
        style={innerContainerStyle}
      >
        <div className={Style.content}>
          {image && <Image source={image} className={Style.image} alt="" />}
          <div className={Style.previewPassExpiredHeading}>{headerText}</div>
          <div className={Style.previewPassExpiredSubheading}>{text}</div>
          <button onClick={openOverlay} className={Style.previewPassButton}>
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

Legacy.defaultProps = {
  isActive: false,
  openOverlay: null,
  backgroundInline: null,
  sharedTheme: {},
};

Legacy.propTypes = {
  isActive: PropTypes.bool,
  openOverlay: PropTypes.func,
  backgroundInline: PropTypes.shape({}),
  sharedTheme: PropTypes.shape({}),
};

export default Legacy;
